// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.align-items-center {
  align-items: center;
}
.align-items-center img {
  background-color: #206ead;
  padding: 1em;
  width: 80%;
}

.login-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/account/components/login-form/login-form.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;AACI;EACI,yBAAA;EACA,YAAA;EACA,UAAA;AACR;;AAEA;EACI,WAAA;AACJ","sourcesContent":[".align-items-center{\n    align-items: center;\n\n    img{\n        background-color: #206ead;\n        padding: 1em;\n        width: 80%;\n    }\n}\n.login-form-field{\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
